export default __webpack_public_path__ + "static/media/clear-night.d737d736.svg";